export default "__VITE_PUBLIC_ASSET__a806a8f4__"